function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:url(#SVGID_1_);}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M50.8,10.6c-0.9-1.1-2.3-1.7-3.8-1.7h-2.6V8.4c0-1.8-1.4-3.2-3.2-3.2h-23c-1.8,0-3.2,1.4-3.2,3.2v0.4H13 c-1.5,0-2.9,0.6-3.8,1.7c-1,1.1-1.4,2.7-1.1,4.1l2.3,11.6c0.4,2.3,2.5,4,4.8,4H17c1.7,3,4.3,5.4,7.5,6.8c1.8,0.8,2.9,2.7,2.6,4.7 l-0.9,5.1c-0.4,2.1-2.2,3.6-4.3,3.6l0,0c-0.6,0-1.1,0.2-1.5,0.6c-0.4,0.4-0.6,0.9-0.6,1.5c0,1.2,1,2.2,2.2,2.2h15.5 c0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.7-1,0.6-1.7c-0.1-1.1-1-2-2.2-2l0,0c-2.1,0-3.9-1.5-4.2-3.6l-0.9-5.2c-0.3-2,0.7-3.9,2.6-4.7 c3.2-1.4,5.9-3.8,7.5-6.8h2.4c2.3,0,4.4-1.7,4.8-4l2.2-11.6C52.2,13.2,51.8,11.7,50.8,10.6z M15.2,28c-1.2,0-2.3-0.9-2.5-2.1 l-2.3-11.6c-0.2-0.8,0.1-1.5,0.5-2.1c0.5-0.6,1.2-0.9,2-0.9h2.2v11.6c0,1.8,0.3,3.6,0.9,5.2L15.2,28L15.2,28z M49.6,14.3l-2.2,11.6 c-0.2,1.2-1.3,2.1-2.6,2.1h-1.3c0.6-1.6,0.9-3.4,0.9-5.2V11.2h2.7c0.8,0,1.5,0.3,2,0.9C49.6,12.7,49.8,13.5,49.6,14.3z"
});

var SvgMainMood = function SvgMainMood(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.7784,
    y1: 5.9476,
    x2: 45.4583,
    y2: 64.9591,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#19F2C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CC31FF"
    }
  })), _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMainMood, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mainMood.75d2fe3d.svg";
export { ForwardRef as ReactComponent };